import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xcesem9dr: FaireProductEntity = {
  token: "p_4xcesem9dr",
  type: "product",
  name: "Paved Halo Solitaire Moissanite Ring",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/6e225842b05b0adbea3e5503d31a61c5cc73011e11430c7b08b1a13cc4b8ffda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ccdf154f0c972f8e37fbdf97e591ed213ed63cc21c409990e42b9dd701cd09b.jpeg",
    "https://cdn.faire.com/fastly/6c3617c265e7e9ed45f69dd1c6978e951d3eee2ef3a607b41696716fb747baa6.jpeg",
    "https://cdn.faire.com/fastly/625a50d5de0dac24a7b1ed05a3f70fe471056c9c956c38491aa70aa41f832d6b.jpeg",
    "https://cdn.faire.com/fastly/a600be3b4b5a561cb88807f5d1adeddc7052b705f486c6d749e1361a2e2ce04b.jpeg",
    "https://cdn.faire.com/fastly/0361ecc1dc96ca98567af40aea9c442968909992d8d5fd84dc80359f6d131274.jpeg",
  ],
  priceDollars: 55.52,
  description:
    "Experience the perfect combination of beauty and elegance with our Paved Halo Solitaire Moissanite Ring. The dainty band showcases the stunning sparkle of the moissanite, making it the perfect accessory for any occasion.\n\nDimensions: size 7\n\nWhite gold plated sterling silver\n\n2 carat brilliant Moissanite, color GH, color VS1\n\nLead and nickel free\n\nCrafted in China",
  tags: [],
  msrpDollars: 138.81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:55.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
